import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=0b9ef5b8&scoped=true"
import script from "./BlogItem.vue?vue&type=script&lang=js"
export * from "./BlogItem.vue?vue&type=script&lang=js"
import style0 from "./BlogItem.vue?vue&type=style&index=0&id=0b9ef5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ef5b8",
  null
  
)

export default component.exports